/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import React from 'react';

import { KitElement } from 'shared/kit/kit-element';
import { DEFAULT_COLOR, KitOutfit } from 'shared/kit/kit-outfit';
import { KitPattern } from 'shared/kit/kit-pattern';

import { PatternOverlay } from './garment-pattern';

interface KitSwatchProps {
  elements: KitElement[];
  elementStates: Partial<KitOutfit>;
}

export const KitSwatch: React.FC<KitSwatchProps> = ({ elements, elementStates }) => (
  <div
    css={css`
      display: flex;
      flex: 0 0 auto;
      gap: 4px;
      align-items: center;
    `}
  >
    {elements.slice(0, 3).map((el) => {
      const state = elementStates[el];
      const primaryColor = state?.colors[0] ?? DEFAULT_COLOR;
      const secondaryColor = state?.colors[1];
      const pattern = state?.pattern ?? KitPattern.SOLID;
      return (
        <svg key={el} width="14" height="14" viewBox="0 0 14 14">
          <rect width="14" height="14" rx="2" fill={primaryColor} stroke="rgba(0,0,0,0.15)" strokeWidth="1" />
          {pattern !== KitPattern.SOLID && secondaryColor && (
            <PatternOverlay pattern={pattern} color2={secondaryColor} width={14} height={14} rx={2} />
          )}
        </svg>
      );
    })}
  </div>
);

export default KitSwatch;
